<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'App'
}
</script>

<style>
@font-face {
    font-family: 'Daydream';
    src: 
        url('./assets/Daydream.ttf') format('ttf'),
        url('./assets/Daydream.woff2') format('woff2'),
        url('./assets/Daydream.woff') format('woff');
    font-weight: 100;
    font-style: normal;
    font-display: swap;
}

  body {
    font-family: 'Daydream', Helvetica, sans-serif;
    color: #0f0;
    margin: 0;
    padding: 0;
    background-color: rgb(3, 3, 187);
    user-select: none;
  }

.relative {
  position: relative;
  width: 100vw;
  height: 100vh;
}

.absolute-vh-centered {
  position: absolute;
  top: 50%; left: 50%;
  transform: translate(-50%, -50%);
}



video {
  position: absolute;
  object-fit: cover;
  width: 100vw;
  height: 100vh;
  object-position: center center;
  display: block;
  top: 0;
  left: 0;
}

.text {
    color: #0f0;
    text-transform: uppercase;
    position: absolute;
    left: 50%; top: 50%;
    transform: translate(-50%, -50%);
    text-align: justify;
    text-align-last: center;
    font-size: clamp(2rem, 4vw, 4rem);
    font-weight: 800;
    margin: 0;
}

.ns-btn {
  font-family: 'Daydream';
  text-transform: uppercase;
  background-color: rgb(3, 3, 187);
  color: #0f0;
  font-size: 5vw;
  padding: 0.5rem 3rem;
  cursor: pointer;
  border: 1px solid rgb(3, 3, 187);
}

</style>
